<template>
  <div class="communities">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="Communities"></ContentHeader>
        <section v-if="communities && communities.length">
          <div class="card-columns">
            <div class="card challenge" v-for="community of communities" v-bind:key="community.id">
              <router-link :to="'/communities/community/' + community.title.rendered.replace(/ /g, '-').toLowerCase()">
                <div class="featuredImg" v-if="community.hasImage === true">
                    <img :src="community.featureImageUrl"
                      :alt="community.featureImageAlt"
                      :title="community.featureImageTitle">
                </div>
                <div class="card-body">
                  <h5 class="card-title text-center" v-html="community.title.rendered"></h5>
                  <div v-html="community.content.rendered"></div>
                </div>
              </router-link>
            </div>
          </div>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ContentHeader from '@/components/ContentHeader'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    ContentHeader,
    PreContentHeader
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUserCommunityIDstring'
    ])
  },
  data () {
    return {
      contentReady: false,
      contentLoadError: '',
      communities: []
    }
  },
  created () {
    this.loadContent()
  },
  methods: {
    getAPiCallString: function () {
      if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
        return 'community_categories=' + this.getUserCommunityIDstring
      } else {
        return ''
      }
    },
    loadContent: function () {
      document.title = this.$route.name + ' - ThinkTank'
      WordpressRestAPI.getViewContent('communities?_embed&' + this.getAPiCallString() + '&per_page=100')
        .then(response => {
          this.communities = response.data
          for (var i = 0; i < this.communities.length; i++) {
            this.communities[i].hasImage = false
            this.communities[i].featureImageUrl = ''
            this.communities[i].featureImageAlt = ''
            this.communities[i].featureImageTitle = ''
            if (this.communities[i]._embedded['wp:featuredmedia'] !== undefined) {
              if (this.communities[i]._embedded['wp:featuredmedia'][0].media_details !== undefined) {
                this.communities[i].featureImageUrl = this.communities[i]._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url
                this.communities[i].featureImageAlt = this.communities[i]._embedded['wp:featuredmedia'][0].alt_text
                this.communities[i].featureImageTitle = this.communities[i]._embedded['wp:featuredmedia'][0].title.rendered
                this.communities[i].hasImage = true
              }
            }
          }
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading ThinkTank communities. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    getUserCommunityIDstring (newDetails, oldDetails) {
      if (!this.$store.getters.isAdmin) {
        this.loadContent()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/Communities.vue